import React from 'react'

const ShopBanner = (props) => {
    return(
        <section className="wpo-offer-banner-section">
            <div className="container">
                <div className="row">
                    <div className="col col-lg-6 offset-lg-6">
                        <div className="offer-banner-text">
                            <h3>WEDDING SEASON DISCOUNT</h3>
                            <h2><span>up to</span>50% OFF</h2>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ShopBanner;